export const METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export const ENDPOINTS = {
  AUTH: "auth/",
  DASHBOARD: "dashboard/",
  USER: "user/",
  ORDERS: "order/",
  DELIVERY_MODE: "delivery-mode/",
  CATERINGEVENT: "event/",
  ROLES: "roles/",
  TEAMS: "team/",
  LOCATION: "locations",
  COMPANY: "company/",
  PERMISSIONS: "permissions/",
  ROLESPERMISSION: "role-permissions/",
  STATES: "states/",
  PAYMENT: "payment-option/",

  PRODUCT: "products",
  UNITOFMEASUREMENT: "unit-of-measurement/",
  SIDES: "getSides",
  PACKAGETYPE: "package-type",
  EVENT: "events/",
  CATERINGPACKAGE: "catering-package",
  INVENTORY: "inventory-control",
  OPERATION: "operation",
  DRIVER: "driver",
  CATERINGCATEGORY: "catering-category",
  DIETARYPREFERENCE: "dietary-preference",
  EVENTTYPE: "event-type",
  BEVERAGETYPE: "beverage-type",
  VEHICLES: "vehicle",
  SERVICEFEE: "service-fee",
  SERVICETYPE: "service-type",
  TRANSACTION: "transactions",
  RANKS: "rank",
  PROMOS: "promo",
  PROMOTYPE: "promo-type",
  VATFEE: "vat-fee",
  ROLE_PERMISSION: "role-permissions",
  ONBOARDING: "onboarding/",

  // Customer Constant
  CATEGORY: "categories/",
  ACTIVECATERINGPACKAGE: "catering-package/get-active",
  CUSTOMERPACKAGEDETAIL: "catering-category/",
  ROLE_PERMISSION: "role-permissions",
  LGA: "lga",
  DELIVERY_FEE: "delivery-fee",
};
